<main class="container irembogov-convert-existing-service">
  <div class="row">
    <div class="col-md-12">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <button
            type="button"
            class="btn btn-link p-0 mb-2 back"
            (click)="goBack()">
            <i class="fas fa-chevron-left me-2"></i>
            Go Back
          </button>
          <h4>Existing Services</h4>
          <p class="text-muted mb-0">
            Choose the services you want to convert into a template.
          </p>
        </div>
      </div>

      <!-- Organization Selection -->
      <div class="card mb-4">
        <div class="card-body">
          <h5 class="card-title">Select Organization</h5>
          <p class="text-muted">
            Choose an organization to view its live services
          </p>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="organizationSelect" class="form-label"
                  >Organization <span class="text-danger">*</span></label
                >
                <select
                  id="organizationSelect"
                  class="form-select"
                  [disabled]="isLoadingOrganizations"
                  (change)="onOrganizationChange($event)">
                  <option value="">Select an organization</option>
                  <option
                    *ngFor="
                      let org of organizations;
                      trackBy: trackByOrganizationId
                    "
                    [value]="org.id"
                    [selected]="selectedOrganization?.id === org.id">
                    {{ getOrganizationDisplayName(org) }}
                  </option>
                </select>

                <!-- Loading state for organizations -->
                <div
                  *ngIf="isLoadingOrganizations"
                  class="d-flex align-items-center mt-2">
                  <div
                    class="spinner-border spinner-border-sm me-2"
                    role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <span class="text-muted">Loading organizations...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Services Section -->
      <div
        *ngIf="selectedOrganization"
        class="irembogov-convert-existing-service-table">
        <irembogov-irembo-section-message
          type="info"
          *ngIf="!isLoading && services.length < 1"
          class="w-80 mx-auto mt-5 d-block"
          title=""
          message="No live services are available for conversion in this organization."
          [dismissible]="false">
        </irembogov-irembo-section-message>

        <irembogov-custom-table-wrapper
          [isSortVisible]="false"
          [loading]="isLoading"
          [paginationVisible]="true"
          [totalItems]="totalElements"
          [itemsPerPage]="pageSize"
          [currentPage]="currentPage + 1"
          (paginationChange)="onPageChange($event.pageNumber - 1)">
          <div class="extra-filters d-flex flex-row gap-3" rightHeader>
            <div class="form-group service-name-filter-form-group">
              <div class="input-group">
                <span class="input-group-text">
                  <i class="fas fa-search"></i>
                </span>
                <input
                  [(ngModel)]="searchTerm"
                  (ngModelChange)="onSearchChange()"
                  placeholder="Search services by name"
                  type="text"
                  class="form-control" />
              </div>
            </div>
            <div class="form-group category-filter-form-group">
              <div class="input-group">
                <span class="input-group-text">
                  <i class="fas fa-tag"></i>
                </span>
                <select
                  class="form-select"
                  [(ngModel)]="selectedCategory"
                  (ngModelChange)="onCategoryChange($event)">
                  <option value="">All Categories</option>
                  <option
                    *ngFor="let category of categories"
                    [value]="category.id">
                    {{ category.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <table
            body
            aria-label="Convert Existing Services Table"
            class="table">
            <thead>
              <tr>
                <th scope="col" class="text-nowrap">Service Name</th>
                <th scope="col" class="text-nowrap">Category</th>
                <th scope="col" class="text-nowrap">Action</th>
              </tr>
            </thead>
            <tbody class="rounded bg-white" *ngIf="!isLoading">
              <tr *ngFor="let service of services; let index = index">
                <td class="text-wrap">
                  <strong>{{ service.serviceName }}</strong>
                  <div class="text-muted small" *ngIf="service.serviceSummary">
                    {{ service.serviceSummary | slice : 0 : 50 }}
                    {{ service.serviceSummary.length > 50 ? '...' : '' }}
                  </div>
                </td>
                <td class="text-wrap">
                  <strong>{{ service.category.name }}</strong>
                </td>
                <td class="text-nowrap">
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    (click)="convertToTemplate(service)"
                    [disabled]="isConverting">
                    <span
                      *ngIf="isConverting && selectedService?.id === service.id"
                      class="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"></span>
                    Convert to Template
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </irembogov-custom-table-wrapper>
      </div>

      <!-- No Organization Selected State -->
      <div
        *ngIf="!selectedOrganization && !isLoadingOrganizations"
        class="card">
        <div class="card-body text-center p-5">
          <i class="fas fa-building fa-3x text-muted mb-3"></i>
          <h5>Select an Organization</h5>
          <p class="text-muted">
            Please select an organization above to view its services available
            for template conversion.
          </p>
        </div>
      </div>
    </div>
  </div>
</main>

<!-- Template Creation Success Modal -->
<div
  class="modal fade show"
  [style.display]="showTemplateCreationModal ? 'block' : 'none'"
  [class.show]="showTemplateCreationModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="templateCreationModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header border-0 pb-0">
        <h5 class="modal-title" id="templateCreationModalLabel">
          Template Created Successfully!
        </h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="cancelConversion()"></button>
      </div>
      <div class="modal-body pt-2">
        <p class="text-muted mb-2" *ngIf="createdTemplateName">
          <span class="template-name">{{ createdTemplateName }}</span> is now
          ready in the library for creating services.
        </p>
        <p class="text-muted mb-2" *ngIf="!createdTemplateName">
          Your new template is now ready in the library for creating services.
        </p>
        <p class="text-muted mb-0">
          The selected setup was copied, and your original service remains
          unchanged.
        </p>
      </div>
      <div class="modal-footer border-0 pt-2">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="cancelConversion()"
          [disabled]="isNavigating">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="continueConfiguration()"
          [disabled]="isNavigating">
          <span
            *ngIf="isNavigating"
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"></span>
          Continue Configuration
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal backdrop -->
<div *ngIf="showTemplateCreationModal" class="modal-backdrop fade show"></div>
